import { parse } from '@config/theme';
import React, { PropsWithChildren } from 'react';
export const BlogGrid = ({
  children
}: PropsWithChildren) => {
  return <div className={grid}>{children}</div>;
};
const grid = parse({
  display: 'grid'
}, "g1q2xnj4");

require("./Grid.linaria.module.css!=!../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./Grid.tsx");